import { ref, onMounted } from 'vue';
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-70f66670"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "filter-content"
};
const _hoisted_2 = {
  class: "filter-list-content"
};
const _hoisted_3 = {
  class: "input-select-content"
};
const _hoisted_4 = {
  class: "filter-list"
};
const _hoisted_5 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "支付渠道", -1));
const _hoisted_6 = {
  class: "filter-list"
};
const _hoisted_7 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "Paychnl", -1));
const _hoisted_8 = {
  class: "filter-list"
};
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "类型", -1));
const _hoisted_10 = {
  class: "filter-list"
};
const _hoisted_11 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "condition-title"
}, "回调地址", -1));
const _hoisted_12 = {
  class: "btn-content"
};
import AccountTableBlock from '@/views/payChanlManage/components/AccountTableBlock.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {
    const querySearch = ref({
      dictDesc: undefined,
      dictDetailCode: undefined,
      payFor: undefined,
      callbackSuffix: undefined
    });
    const channelList = ref([]);
    const payChnlList = ref([]);
    const typeList = ref([{
      label: 'APP',
      value: 1
    }, {
      label: '小游戏',
      value: 2
    }, {
      label: 'PC',
      value: 3
    }]);
    const EntityList = ref([]);
    const EntityListTable = ref([]);
    const accountTableRef = ref();
    const filterSubmit = params => {
      querySearch.value = params;
      accountTableRef.value.pageIndex = 1;
      accountTableRef.value.queryList(querySearch.value);
    };
    const changePageTableList = () => {
      // accountTableRef.value.queryList(querySearch.value)
    };
    const getSelect = (channellist, payChannelList) => {
      channelList.value = channellist;
      payChnlList.value = payChannelList;
    };
    onMounted(async () => {});
    return (_ctx, _cache) => {
      const _component_a_select = _resolveComponent("a-select");
      const _component_a_input = _resolveComponent("a-input");
      const _component_a_button = _resolveComponent("a-button");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createVNode(_component_a_select, {
        allowClear: "",
        value: querySearch.value.dictDesc,
        "onUpdate:value": _cache[0] || (_cache[0] = $event => querySearch.value.dictDesc = $event),
        placeholder: "请选择支付渠道",
        options: channelList.value
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_6, [_hoisted_7, _createVNode(_component_a_select, {
        allowClear: "",
        value: querySearch.value.dictDetailCode,
        "onUpdate:value": _cache[1] || (_cache[1] = $event => querySearch.value.dictDetailCode = $event),
        placeholder: "请选择Paychnl",
        options: payChnlList.value
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_8, [_hoisted_9, _createVNode(_component_a_select, {
        allowClear: "",
        value: querySearch.value.payFor,
        "onUpdate:value": _cache[2] || (_cache[2] = $event => querySearch.value.payFor = $event),
        placeholder: "请选择类型",
        options: typeList.value
      }, null, 8, ["value", "options"])]), _createElementVNode("div", _hoisted_10, [_hoisted_11, _createVNode(_component_a_input, {
        allowClear: "",
        value: querySearch.value.callbackSuffix,
        "onUpdate:value": _cache[3] || (_cache[3] = $event => querySearch.value.callbackSuffix = $event),
        placeholder: "请输入回调地址"
      }, null, 8, ["value"])])]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_a_button, {
        onClick: _cache[4] || (_cache[4] = $event => filterSubmit({
          dictDesc: undefined,
          dictDetailCode: undefined,
          payFor: undefined,
          callbackSuffix: undefined
        }))
      }, {
        default: _withCtx(() => [_createTextVNode("重置")]),
        _: 1
      }), _createVNode(_component_a_button, {
        type: "primary",
        onClick: _cache[5] || (_cache[5] = $event => filterSubmit(querySearch.value))
      }, {
        default: _withCtx(() => [_createTextVNode("搜索")]),
        _: 1
      })])])]), _createVNode(AccountTableBlock, {
        ref_key: "accountTableRef",
        ref: accountTableRef,
        onRefresh: _cache[6] || (_cache[6] = $event => filterSubmit({
          dictDesc: undefined,
          dictDetailCode: undefined,
          payFor: undefined,
          callbackSuffix: undefined
        })),
        onChangePageTableList: changePageTableList,
        onSendSelect: getSelect
      }, null, 512)]);
    };
  }
});